export default "__VITE_ASSET__CSYdeOBF__"